import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './index.scss';
import Select from "react-select";
import { useNavigate } from 'react-router-dom';
import CustomTable from '../../../customComponents/CustomTable';
import { ADVANCESEARCH_HEADERS, ADVANCESEARCH_KEY_MAPPING } from '../../../../constants/AdvanceSearchList';
import axiosInstance from '../../../services/api/API';
import ROUTES_NAVIGATION from '../../../../routes/routes';
import backicon from '../../../../Assets/icons/backIcon.svg';
import Loader from '../../../customComponents/CustomLoader';

const AdvanceSearch = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchType, setSearchType] = useState({ value: 1, label: 'Name' });
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();
  
  const searchTypeOptions = [
    { value: 1, label: 'Name' },
    { value: 2, label: 'Mobile No.' },
    { value: 3, label: 'Email' }
  ];

  useEffect(() => {
    // Load all records initially
    handleSearch();
  }, []);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    handleSearch(newPage);
  };

  const handleSearch = async (page = 0, pageSize = 10) => {
    setLoading(true);
    setError(null);
    try {
      
      const response = await axiosInstance.post('/lead/check-mobile-wise-lead-details', {
       
        searchText: searchQuery || '',
        orderBy: 'lead_customer_id desc',
        page,
        pageSize
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const formattedData = response.data.data.data.map((item, index) => ({
        ...item,
        "Sr No.": index + 1  ,
      //   "priority_name": {
      //   value: item.priority_name,
      //   style: getPriorityStyle(item.priority_name)
      // }
      }));

      const totalRecordsData = response?.data?.data?.totalRecords
      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

      setRecords(formattedData); 
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));

      if (formattedData.length === 0 && searchQuery) {
        navigate(ROUTES_NAVIGATION.ADDLEAD, { state: { searchType: searchType.value, searchQuery } });
      }
    } catch (err) {
      console.error('Error fetching action taken list:', err);
      setError('Error fetching records');
    } finally {
      setLoading(false);
    }
  };

  // const getPriorityStyle = (priority) => {
  //   switch (priority) {
  //     case 'Warm Leads':
  //       return { color: 'red' };
  //     case 'Hot Leads':
  //       return { color: 'blue' };
  //     case 'Cold Leads':
  //       return { color: 'green' };
  //     default:
  //       return {};
  //   }
  // };

  const handleAdd = (rowdata) => {
    navigate(`${ROUTES_NAVIGATION.ALLOWLEAD}`, { state: { data: rowdata, allownewlead: true } });
  };

  const handleEditButton = (rowData) => {
    navigate(`${ROUTES_NAVIGATION.ADDNEWLEAD}`, { state: { data: rowData } });
  };

  const handleViewButton = (rowData) => {
    navigate(`${ROUTES_NAVIGATION.FOLLOWUPREQUIREDDETAILS}`, { state: { data: rowData } });
  };

  const handleActionToBeTaken = (rowData) => {
    navigate(`${ROUTES_NAVIGATION.ACTIONTOBETAKEN}`, { state: { data: rowData } });
  };
   useEffect(() => {
    // Trigger search when searchQuery is cleared
    if (searchQuery === '') {
      handleSearch();
    }
  }, [searchQuery]);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderColor: "#ccc",
      boxShadow: "none",
      borderRadius: "10px",
      "&:hover": {
        borderColor: "#888",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
      height: "50px",
      width: '200px' 
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "5px",
      borderColor: "#ccc",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#7BD755" : state.isFocused ? "#fff" : null,
      "&:hover": {
        backgroundColor: "#7BD755",
        color: "white",
      },
    }),
  };

  const handleNavigate = () => {
    navigate("/admin/manage-lead/lead-allocation/add-new-lead")
  }

  const handleUploadLead = () => {
    navigate(ROUTES_NAVIGATION.LEADUPLOAD)
  }
  const handleKeyDown=(event)=>{
    if(event?.key==="Enter"){
      handleSearch();
    }
  }
  return (
    <>
      {loading ? ( 
        <Loader />
      ) : (
        <>
          <div className="adv-header-container mt-3">
            <div className="backbutton col-lg-4 mt-2 mb-2" onClick={() => navigate(ROUTES_NAVIGATION.ADVANCESEARCH)}>
              {/* <img src={backicon} alt="back" /> */}
              <div className="adv-header">Advance Search</div>
            </div>
            <div className="advbtnleadcontainer col-lg-8">
              <button className="advbtnlead" onClick={() => navigate(ROUTES_NAVIGATION.ADDLEAD)}>Add Lead</button>
              <button onClick={handleUploadLead} className='upload-btn'>Upload Lead</button>
            </div>
          </div>
  
          <div className="search-component">
            <div className="search-bar row">
              <div className="col-lg-8">
                <label className="adv-label">Search Type</label>
                <input
                  className="advancesearchinput"
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder={`Search by Name, Mobile No., Email`}
                  onKeyDown={handleKeyDown}
                />
              </div>
              <div className="searchbtncontainer col-lg-2 mt-3">
                <button onClick={() => handleSearch(0)} className="search-btn">Search</button>
              </div>
            </div>
          </div>
  
          <div>
            {!loading && !error && records.length > 0 && (
              <CustomTable
                data={records}
                headers={ADVANCESEARCH_HEADERS}
                keyMapping={ADVANCESEARCH_KEY_MAPPING}
                itemsPerPage={10}
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onEdit={handleEditButton}
                onAdd={handleAdd}
                handleViewButton={handleViewButton}
                actionToBeTaken={handleActionToBeTaken}
                isOpenStatus={true}
                totalRecords={totalRecords} 
              />
            )}
          </div>
        </>
      )}
    </>
  );
  
};

export default AdvanceSearch;
